import React from "react";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";

import { initI18n } from "js/i18n";
import { getInitialLocale } from "js/i18n/locale";

//
// entry point
//

const root = document.createElement("div");
root.id = "react-root";
root.style.display = "contents";
document.body.appendChild(root);

(async () => {
    const { init } = await import(/* webpackMode: "eager" */ "js/firebase/init");
    await init();

    await import(/* webpackMode: "eager" */ "js/preload");

    const { default: Adapter } = await import(/* webpackMode: "eager" */ "js/core/storage/adapter");
    const { default: FirebaseAdapter } = await import(/* webpackMode: "eager" */ "js/core/storage/firebaseAdapter");
    Adapter.setDefaultClass(FirebaseAdapter);

    const i18nInstance = initI18n(getInitialLocale());

    const { default: PPTAddin } = await import(/* webpackMode: "eager" */ "js/react/views/PPTAddin/PPTAddin");

    ReactDOM.render(
        <I18nextProvider i18n={i18nInstance}>
            <PPTAddin />
        </I18nextProvider>,
        root
    );
})();

